import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import axios from "axios";
import { server_API } from "../config";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip } from "react-tooltip";
import { useSelector } from "react-redux";
import { selectCid } from "../features/companyid";
import Select from "react-select";
import { IoMdArrowBack } from "react-icons/io";
import { FaInfoCircle } from "react-icons/fa";
import { selectUuid, getUserPrivilege } from "../features/userid";
import Copyright from "./Copyright";
import axiosInstance from "../axiosInstance";
import { roleTypes } from "../constants/common";

const itemsPerPage = 10;
const AccessOptions = [
  { value: roleTypes.admin, label: roleTypes.admin },
  { value: roleTypes.recruiter, label: roleTypes.recruiter },
  { value: roleTypes.hiringManager, label: roleTypes.hiringManager },
];

const User = () => {
  const [open, setOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [companyUsers, setCompanyUsers] = useState([]);
  const [name, setName] = useState("");
  const [access, setAccess] = useState("");
  const [view, setView] = useState(false);
  const [admin, setAdmin] = useState(false);
  const [recruiter, setRecruiter] = useState(false);
  const [hiringManager, setHiringManager] = useState(false);
  const [uuid, setUuid] = useState("");
  const [ws, setWs] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginatedUsers, setPaginatedUsers] = useState([]);
  const location = useLocation();
  const [companyStatus, setCompanyStatus] = useState(true);
  const navigate = useNavigate();
  const [info, setInfo] = useState(false);
  const [action, setAction] = useState("");
  const [isApprover, setIsApprover] = useState(false);
  const [salaryApprover, setSalaryApprover] = useState(false);
  const [jobApprover, setJobApprover] = useState(false);
  const [offerLetterApprover, setOfferLetterApprover] = useState(false);
  const [signature, setSignature] = useState(null);
  const [existingSignature, setExistingSignature] = useState(null);
  const [hasApproverFlow, setHasApproverFlow] = useState(false);

  const userid = useSelector(selectUuid);
  const userPrivilege = useSelector(getUserPrivilege);
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    if (admin) {
      setWs(roleTypes.admin);
    } else if (recruiter) {
      setWs(roleTypes.recruiter);
    } else if (hiringManager) {
      setWs(roleTypes.hiringManager);
    }
  }, [admin, recruiter, hiringManager]);

  const save = () => {
    console.log(uuid);
    console.log(ws, name);
    const formData = new FormData();
    formData.append("companyid", cid);
    formData.append("name", name);
    formData.append("uuid", uuid);
    formData.append("privilege", ws);
    formData.append("is_approver", isApprover);
    formData.append("salary_approver", salaryApprover);
    formData.append("job_approver", jobApprover);
    formData.append("offer_letter_approver", offerLetterApprover);
    if (signature) {
      formData.append("signature", signature);
    }

    axiosInstance
      .patch(`/v2/user/update`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log(response);
        window.location.reload();
        setView(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    axios
      .get(`${server_API}/v2/company/get/${cid}`)
      .then((response) => {
        if (response.data.companystatus !== undefined) {
          setCompanyStatus(response.data.companystatus);
        } else {
          setCompanyStatus(true);
        }
        setHasApproverFlow(response.data.hasApproverFlow || response.data.offerApproval);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const change = (e) => {
    setView(true);
    setName(e.name);
    setUuid(e.uuid);
    setIsApprover(e.is_approver || false);
    setSalaryApprover(e.salary_approver || false);
    setJobApprover(e.job_approver || false);
    setOfferLetterApprover(e.offer_letter_approver || false);
    setSignature(null); // Reset signature on open, as we don't necessarily want to re-upload it unless changed
    setExistingSignature(e.signature || null);

    if (e.privilege === roleTypes.admin) {
      setAdmin(true);
      setRecruiter(false);
      setHiringManager(false);
    } else if (e.privilege === roleTypes.recruiter) {
      setAdmin(false);
      setRecruiter(true);
      setHiringManager(false);
    } else if (e.privilege === roleTypes.hiringManager) {
      setRecruiter(false);
      setAdmin(false);
      setHiringManager(true);
    }
  };

  const deleteUser = (id) => {
    axiosInstance
      .delete(`/v2/user/delete/${id}`)
      .then((response) => {
        console.log(response);
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // const cid = localStorage.getItem('cid')
  const cid = useSelector(selectCid);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get(`${server_API}/v2/user/company/${cid}`)
      .then((response) => {
        console.log(response);
        setUsers(response.data.message.Users);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (users.length > 0 && cid.length > 0) {
      console.log(users, cid);
      const new_users = users.filter((m) => {
        console.log(m);
        if (cid === m.companyid && m.status === "accepted") {
          return m;
        }
      });
      if (access.length > 0) {
        const filtered_users = new_users.filter((m) => {
          if (m.privilege === access) {
            return m;
          }
        });
        setCompanyUsers(filtered_users);
      } else {
        setCompanyUsers(new_users);
      }
    } else {
      setCompanyUsers(users);
    }
  }, [users, cid, access]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const indexOfLastJob = currentPage * itemsPerPage;
  const indexOfFirstJob = indexOfLastJob - itemsPerPage;
  useEffect(() => {
    if (companyUsers.length > 0) {
      setPaginatedUsers(companyUsers.slice(indexOfFirstJob, indexOfLastJob));
    } else {
      setPaginatedUsers([]);
    }
  }, [currentPage, companyUsers, indexOfFirstJob, indexOfLastJob]);

  // const currentJobs = sortedJobs.slice(indexOfFirstJob, indexOfLastJob);

  const totalPages = Math.ceil(companyUsers?.length / itemsPerPage);

  const getPageRange = () => {
    const maxVisiblePages = 3;
    const middlePage = currentPage;
    let startPage = middlePage - Math.floor(maxVisiblePages / 2);
    startPage = Math.max(startPage, 1);
    const endPage = Math.min(startPage + maxVisiblePages - 1, totalPages);
    return Array.from(
      { length: endPage - startPage + 1 },
      (_, i) => startPage + i
    );
  };

  const options = [
    { value: "edit", label: "Edit" },
    { value: "delete", label: "Delete" },
  ];

  const tooltipRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setInfo(false);
      }
    }

    if (info) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [info]);

  return (
    <div>
      <Tooltip id="my-tooltip" />
      {deleteModal && (
        <div className="bg-white rounded-xl z-40 shadow-2xl max-w-1/2 w-1/2 p-4 fixed -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2">
          <p className="font-semibold text-center">
            Are you sure you want to delete the user?
          </p>
          <div className="flex w-full mt-5 justify-around">
            <button
              className="text-red-500 border-red-500 border rounded-xl py-2 px-5 "
              onClick={() => {
                setDeleteModal(false);
              }}
            >
              Cancel
            </button>
            <button
              className="bg-red-500 text-white border-red-500 border rounded-xl py-2 px-6 "
              onClick={() => {
                deleteUser(uuid);
              }}
            >
              Delete
            </button>
          </div>
        </div>
      )}
      {view && (
        <div className="bg-white z-40 rounded-xl shadow-2xl max-w-1/2 w-1/2  fixed -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2">
          <div className=" rounded-xl  flex flex-col ">
            <div className="flex p-4 items-center justify-between">
              <p className="text-xl font-medium">Edit Access</p>
              <button
                onClick={() => {
                  setView(false);
                }}
                className="text-right"
              >
                X
              </button>
            </div>
            <div className="bg-[#E9EBFA] h-[0.1rem] w-full"></div>
            <div className="p-4">
              <p className="font-semibold">User Name</p>
              <input
                className="mt-3 outline-none border rounded-sm px-2 py-1 w-full"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
              ></input>
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2">
                <p className="font-semibold">
                  Access for <span className="text-red-400">*</span>
                </p>
                <div className="tooltip relative" ref={tooltipRef}>
                  <button
                    onClick={() => {
                      setInfo(!info);
                    }}
                  >
                    <FaInfoCircle className="text-lg mt-[0.5rem]"></FaInfoCircle>
                  </button>
                  {info && (
                    <div className="fixed rounded-xl z-50 p-3 mr-3 bg-[#1d2a3c]">
                      <div className="text-white">
                        <strong>Admin:</strong> Full administrative control over
                        the ATS, including user management, system
                        configurations, and access to all data and features.{" "}
                        <br />
                        <br />
                        <strong>Recruiter:</strong> Manage job postings, review
                        submitted candidates, schedule interviews, and add
                        candidate ratings and notes. No administrative access.
                        <br />
                        <br />
                        <strong>Hiring Manager:</strong> Review submitted
                        candidates, schedule interviews, and add candidate
                        ratings and notes. No administrative or job creation
                        access.
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex my-2 items-center w-full space-x-3">
                <div className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    onChange={(e) => {
                      if (e.target.checked == true) {
                        setAdmin(true);
                        setRecruiter(false);
                        setHiringManager(false);
                      }
                    }}
                    checked={admin}
                    className="w-4 h-4 rounded-full border border-gray-200 appearance-none checked:bg-blue-500 checked:border-blue-500 cursor-pointer"
                  ></input>
                  <p>Admin</p>
                </div>
                <div className="flex items-center space-x-2">
                  <input
                    onChange={(e) => {
                      if (e.target.checked == true) {
                        setAdmin(false);
                        setRecruiter(true);
                        setHiringManager(false);
                      }
                    }}
                    checked={recruiter}
                    type="checkbox"
                    className="w-4 h-4 rounded-full border border-gray-200 appearance-none checked:bg-blue-500 checked:border-blue-500 cursor-pointer"
                  ></input>
                  <p>Recruiter</p>
                </div>
                <div className="flex items-center space-x-2">
                  <input
                    onChange={(e) => {
                      if (e.target.checked == true) {
                        setAdmin(false);
                        setRecruiter(false);
                        setHiringManager(true);
                      }
                    }}
                    checked={hiringManager}
                    type="checkbox"
                    className="w-4 h-4 rounded-full border border-gray-200 appearance-none checked:bg-blue-500 checked:border-blue-500 cursor-pointer"
                  ></input>
                  <p>Hiring Manager</p>
                </div>
              </div>

            </div>
          </div>

          {/* Approver Selection */}
          {hasApproverFlow && (
            <div className="mt-4 mx-4">
              <p className="font-semibold mb-2">Is Approver?</p>
              <div className="flex space-x-4">
                <div className="flex items-center space-x-2">
                  <input
                    type="radio"
                    id="approverYes"
                    name="isApprover"
                    value="yes"
                    checked={isApprover === true}
                    onChange={() => setIsApprover(true)}
                    className="cursor-pointer"
                  />
                  <label htmlFor="approverYes" className="cursor-pointer">Yes</label>
                </div>
                <div className="flex items-center space-x-2">
                  <input
                    type="radio"
                    id="approverNo"
                    name="isApprover"
                    value="no"
                    checked={isApprover === false}
                    onChange={() => {
                      setIsApprover(false);
                      setSalaryApprover(false);
                      setJobApprover(false);
                      setOfferLetterApprover(false);
                    }}
                    className="cursor-pointer"
                  />
                  <label htmlFor="approverNo" className="cursor-pointer">No</label>
                </div>
              </div>

              {/* Sub-Roles Checkboxes (Visible only if Is Approver is Yes) */}
              {isApprover && (
                <div className="mt-3 flex space-x-6">
                  <div className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      checked={salaryApprover}
                      onChange={(e) => setSalaryApprover(e.target.checked)}
                      className="w-4 h-4 rounded-sm border border-gray-200 cursor-pointer"
                    />
                    <p>Salary Approver</p>
                  </div>
                  <div className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      checked={jobApprover}
                      onChange={(e) => setJobApprover(e.target.checked)}
                      className="w-4 h-4 rounded-sm border border-gray-200 cursor-pointer"
                    />
                    <p>Job Approver</p>
                  </div>
                  <div className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      checked={offerLetterApprover}
                      onChange={(e) => setOfferLetterApprover(e.target.checked)}
                      className="w-4 h-4 rounded-sm border border-gray-200 cursor-pointer"
                    />
                    <p>Offer Letter Approver</p>
                  </div>
                </div>
              )}

              {/* Signature Upload */}
              {offerLetterApprover && (
                <div className="my-4">
                  <p className="font-semibold">Signature</p>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => setSignature(e.target.files[0])}
                    className="mt-2 w-full text-sm text-gray-500
                      file:mr-4 file:py-2 file:px-4
                      file:rounded-full file:border-0
                      file:text-sm file:font-semibold
                      file:bg-blue-50 file:text-blue-700
                      hover:file:bg-blue-100"
                  />
                  {/* Optional: Show existing signature status if needed, but not in current requirements */}
                </div>
              )}
            </div>
          )}

          <div className="bg-[#E9EBFA] h-[0.1rem] w-full"></div>
          <div className="flex  px-4 py-5 items-center justify-end w-full">
            <button
              className={`px-6 py-2 text-white rounded-sm ${offerLetterApprover && !signature && !existingSignature ? "bg-gray-400 cursor-not-allowed" : "bg-[#148EFF]"}`}
              onClick={() => {
                save();
              }}
              disabled={offerLetterApprover && !signature && !existingSignature}
            >
              Save
            </button>
          </div>
        </div>
      )
      }
      {
        !companyStatus && (
          <div className="">
            <div className="fixed bg-white border shadow-xl md:w-1/2  p-4 z-40 rounded-xl left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
              <div className="p-3 rounded-xl text-center  flex flex-col space-y-4">
                <div className="flex  items-center justify-between">
                  <p className="text-xl font-medium">Warning</p>
                  <button
                    onClick={() => {
                      navigate("/home");
                    }}
                    className="text-right"
                  >
                    X
                  </button>
                </div>
                <div className="h-[0.08rem] w-full  bg-gray-300"></div>
                <div>
                  <p className="my-6 font-semibold">
                    Your plan has expired and account has been suspended. Please
                    activate the account by renewing with a suitable plan for
                    continued access to the system.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )
      }
      <div
        className={
          deleteModal || view || !companyStatus
            ? "bg-[#f0f4fc] min-h-screen pointer-events-none blur"
            : "bg-[#f0f4fc] min-h-screen "
        }
      >
        <div className="pt-5 px-10">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <IoMdArrowBack
                className="text-2xl my-3 tooltip cursor-pointer"
                onClick={() => {
                  navigate(-1);
                }}
              >
                back
              </IoMdArrowBack>
              <p className="text-2xl font-semibold">Users</p>
            </div>
            <div className="relative">
              <Link to="/user/new">
                <button
                  className="py-2 h-full  w-52 bg-[#148EFF] text-white px-6 rounded-lg"
                  onClick={() => {
                    setOpen(!open);
                  }}
                >
                  Add New User
                </button>
              </Link>
            </div>
          </div>
          <div className="p-4 mt-6 bg-white rounded-xl">
            <div className="flex w-full items-end justify-start space-x-5">
              <div className="flex flex-col gap-2">
                <p className="font-semibold">Access For</p>
                <Select
                  options={AccessOptions}
                  value={AccessOptions.find(
                    (option) => option.value === access
                  )}
                  onChange={(selectedOption) => setAccess(selectedOption.value)}
                  placeholder="Select Access For"
                />
              </div>
            </div>
            <div className="mt-10 text-sm">
              {paginatedUsers?.length > 0 ? (
                <div className="mt-10">
                  <Table className="border-y">
                    <Thead className=" top-0 z-30 bg-white">
                      <Tr>
                        <Th className="border-y items-center py-5">S. No.</Th>
                        <Th className="border-y items-center  p-2 ">Name</Th>
                        <Th className="border-y items-center  p-2">Email</Th>
                        <Th className="border-y items-center p-2">Access</Th>
                        <Th className="border-t-[1px] items-center  p-2">
                          Actions
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {paginatedUsers.map((e, i) => {
                        return (
                          <Tr className="text-center">
                            <Td className="border-y items-center p-2">
                              {indexOfFirstJob + i + 1}
                            </Td>
                            <Td className="border-y items-center p-2 ">
                              {e.name}
                            </Td>
                            <Td className="border-y items-center p-2">
                              {e.email}
                            </Td>
                            <Td className="border-y items-center p-2">
                              {e.privilege}
                            </Td>
                            <Td
                              className="border-t-[1px] flex  justify-center items-center  p-2 flex-col"
                              onMouseEnter={() => {
                                if (
                                  userPrivilege === roleTypes.admin &&
                                  userid === e.uuid
                                )
                                  setShowWarning(true);
                              }}
                              onMouseLeave={() => setShowWarning(false)}
                            >
                              {/* <div className="flex w-full justify-start  space-x-4">
                        <button onClick={()=>{change(e)}}>
                          <a data-tooltip-id="my-tooltip" data-tooltip-content="Edit">
                            <img className="h-8 rounded-xl border-[#f0ecfc]  p-2  border "  src={edit}></img>
                          </a>
                        </button>
                        <button onClick={()=>{
                          setUuid(e.uuid)
                          setDeleteModal(true)
                          }}>
                            <a data-tooltip-id="my-tooltip" data-tooltip-content="Delete">
                              <img className="h-8 p-2 rounded-xl border-[#f0ecfc]  border "  src={bin}></img>
                            </a>
                        </button>
                      </div> */}
                              <Select
                                value={action}
                                options={options}
                                className="w-40"
                                placeholder="Select Action"
                                isDisabled={
                                  userPrivilege !== roleTypes.admin ||
                                  userid === e.uuid
                                }
                                onChange={(selectedOption) => {
                                  if (selectedOption.value === "edit") {
                                    change(e);
                                  } else if (
                                    selectedOption.value === "delete"
                                  ) {
                                    setUuid(e.uuid);
                                    setDeleteModal(true);
                                  }
                                }}
                              />

                              {showWarning && userid === e.uuid && (
                                <div className="group relative">
                                  <div className="absolute transition-all -translate-x-1/2 left-1/2 p-3 z-50 border-2 border-red-500 rounded-lg bg-white shadow-md text-[0.7rem] text-red-500 mt-1 whitespace-nowrap">
                                    <span>User can't change own access</span>
                                  </div>
                                </div>
                              )}
                            </Td>
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                </div>
              ) : (
                <div>No data to be displayed</div>
              )}
            </div>
            <nav className="bg-white px-4 py-6 flex items-center justify-between border-t border-gray-200 sm:px-6 ">
              <div className="hidden sm:block">
                {companyUsers?.length !== 0 ? (
                  <p className="text-sm text-gray-700">
                    {indexOfFirstJob + 1} to{" "}
                    {companyUsers?.length < indexOfLastJob
                      ? companyUsers?.length
                      : currentPage !== totalPages
                        ? indexOfLastJob
                        : companyUsers?.length}{" "}
                    of {companyUsers?.length} User
                  </p>
                ) : (
                  <p className="text-sm text-gray-700">
                    {0} to {0} of {companyUsers?.length} users
                  </p>
                )}
              </div>
              <div className="flex justify-between sm:justify-end gap-1">
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 ${currentPage === 1 ? "opacity-50" : "hover:bg-gray-50"
                    }`}
                >
                  Previous
                </button>
                <div className="flex space-x-2">
                  {currentPage > 4 && (
                    <>
                      <button
                        onClick={() => handlePageChange(1)}
                        className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 ${currentPage === 1 ? "bg-light-blue text-white" : ""
                          }`}
                      >
                        1
                      </button>
                      <button
                        onClick={() => handlePageChange(2)}
                        className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 ${currentPage === 2 ? "bg-light-blue text-white" : ""
                          }`}
                      >
                        2
                      </button>
                      <span className="px-2 text-gray-500 text-4xl flex ">
                        ...
                      </span>
                    </>
                  )}
                  {getPageRange().map((page) => (
                    <button
                      key={page}
                      onClick={() => handlePageChange(page)}
                      className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 ${currentPage === page ? "bg-light-blue text-white" : ""
                        }`}
                    >
                      {page}
                    </button>
                  ))}
                </div>
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 ${currentPage === totalPages
                    ? "opacity-50"
                    : "hover:bg-gray-50"
                    }`}
                >
                  Next
                </button>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <Copyright />
    </div >
  );
};

export default User;
